module.exports = __webpack_public_path__ + "img/test_ban.29593f2b.png";